import { useInfiniteQuery } from '@tanstack/react-query';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationTestFixture } from '@/types/automations.ts';
import { AUTOMATION_TEST_FIXTURES_KEY } from '@/utils/queryKeys.ts';
import { get_automation_test_fixtures_url } from '@/utils/urls.ts';

const useRetrieveAutomationTestFixtures = (enabled = true) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  const query = useInfiniteQuery({
    queryKey: [...AUTOMATION_TEST_FIXTURES_KEY(automationId), 'all'],
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam }): Promise<{ fixtures: AutomationTestFixture[]; next_cursor?: string | null }> =>
      (await apiClient.get(get_automation_test_fixtures_url(automationId), {
        params: { collection: 'all', limit: 50, ...(pageParam ? { cursor: pageParam } : {}) },
      })).data,
    getNextPageParam: (page) => page.next_cursor ?? undefined,
    enabled: enabled && !!automationId,
  });
  return {
    ...query,
    data: query.data ? { fixtures: query.data.pages.flatMap((page) => page.fixtures) } : undefined,
  };
};

export default useRetrieveAutomationTestFixtures;
